import script from "./AdminModeration.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminModeration.vue?vue&type=script&setup=true&lang=js"

import "./AdminModeration.vue?vue&type=style&index=0&id=c744457e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c744457e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QIcon,QSkeleton,QPagination});
